// extracted by mini-css-extract-plugin
export var centerText = "_6d-8";
export var container = "_6d-0";
export var doughnutContainer = "_6d-7";
export var legend = "_6d-a";
export var legendItemColorDisplay = "_6d-b";
export var legendItemLabel = "_6d-d";
export var legendItemValue = "_6d-c";
export var lg = "_6d-5";
export var maxWidth = "_6d-9";
export var md = "_6d-4";
export var responsive = "_6d-6";
export var sm = "_6d-3";
export var xs = "_6d-2";
export var xxs = "_6d-1";